import React, { useMemo } from "react";
import { tooltipDataType } from "./ComparisonChart";
import { formatNumber } from "@/utils/numbers";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";

export const CustomTooltip: React.FC<{
  data: tooltipDataType;
}> = ({ data }) => {
  const { t } = useTranslation();
  const YOU = useMemo(() => t(`comparison.titles.you`), [t]);
  const INDUSTRY = useMemo(() => t(`comparison.titles.industry`), [t]);

  const renderTitle = () => {
    if (data.title === YOU) {
      return data.title;
    }
    if (data.title === INDUSTRY) {
      return t("comparison.industryTooltip");
    }
    const lowerCaseTitle = data.title.toLocaleLowerCase();
    return `${t("comparison.tooltip")} ${lowerCaseTitle}`;
  };

  const renderAmount = () => {
    const { value, currencySign } = formatNumber(
      data.amount,
      0,
      data.unit ? false : true,
      false
    );
    if (data.unit) {
      return `${value}${data.unit}`;
    }
    return `${data.showCurrencySign ? currencySign : ""}${value}`;
  };
  return (
    <div className="relative">
      <Text
        data-test="pipeline-funnel-tooltip"
        as="div"
        variant="body"
        className="z-50 max-w-24 overflow-hidden rounded-md border-0 bg-surface-tooltip-toast px-3 py-1.5 shadow-md"
      >
        <div className="h-full w-full flex flex-col gap-3">
          {data.hideIndustry ? (
            <div className="text-sm">
              {t("comparison.switchToMilestonesMessage")}
            </div>
          ) : (
            <>
              <Text as="div" variant="labelSecondary">
                {renderTitle()}
              </Text>
              <div className="text-primary">{renderAmount()}</div>
            </>
          )}
        </div>
      </Text>
      <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-t-[10px] border-t-surface-tooltip-toast"></div>
    </div>
  );
};
